export default __webpack_public_path__ + "media/background.9d3bd88235c8f00ff7bbfe78764bb51e.webp";